import { setTheme } from "theme/default/setTheme";

export const setColor_7b7b7b = setTheme(({ theme }) => `color: ${theme.colors.color_7b7b7b}`);
